import React, {
  useCallback,
  useEffect,
  useState,
} from 'react';
import {FieldComponent} from '../../../types/FieldComponent';
import {compareText} from '../comparators/compareText';
import {TextFilter} from '../filters/TextFilter';
import {debounce} from 'lodash';
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";
import * as Icons from "@mui/icons-material";
import {Stack} from "@mui/material";

export const SPStatusField: FieldComponent<string, string[]> = ({
                                                                onChange,
                                                                defaultValue,
                                                                forcedValue,
                                                                disabled,
                                                                isMissing,
                                                              }) => {
  const [currentState, setCurrentState] = useState<any>({
    value: undefined,
    send: false,
  });

  const debouncedChange = useCallback(
    debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  useEffect(() => {
    if (defaultValue) {
      setCurrentState({...currentState, value: defaultValue})
    }
  }, [defaultValue]);

  useEffect(() => {
    if (currentState.send) {
      debouncedChange(currentState.value);
    }
  }, [currentState, debouncedChange]);
  const handleChange = (value: any) => {
    setCurrentState({
      value: value,
      send: true,
    });
  };

  const IconComponent = Icons[currentState.value?.icon?.name as keyof typeof Icons];

  return (
    <>
      <Stack
        direction={'row'}
        alignItems={'center'}
        gap={1}
        width={'100%'}
        sx={{
          background: '#fff',
          p: '5px',
          borderRadius: '4px',
          border: '1px solid #00000042'
        }}
      >

        <Avatar
          sx={{
            background: `${
              currentState.value?.color?.color
                ? currentState.value?.color?.color
                : '#FFFFFF00'
            }`,
            width: 20,
            height: 20,
            '& .MuiSvgIcon-root':{
              fontSize: '16px'
            }
          }}
        >
          {currentState.value?.icon && (
            <>{IconComponent ? <IconComponent /> : null}</>
          )}
        </Avatar>
        <Typography>{currentState?.value?.name}</Typography>
      </Stack>
    </>
  );
};

SPStatusField.includes = (query = [], value = '') => {
  if (query.length === 0 || value === null) return true;
  const valueLowercase = value.toLowerCase();
  return query.some((queryPart) =>
    valueLowercase.includes(queryPart.toLowerCase())
  );
};

SPStatusField.comparator = compareText;

SPStatusField.FilterRenderer = TextFilter;
